import * as DateUtils from "../utils/date/date";
import { Entity } from "./Entity.abstract";

export class RatingEntity extends Entity {
    constructor({
        _id,
        accountingId,
        companyId,
        name,
        email,
        npsId,
        messageId,
        events,
        score,
        comment,
        recommendations,
        companyName
    }) {
        super({
            _id,
            accountingId,
            companyId,
            name,
            email,
            npsId,
            messageId,
            events,
            score,
            comment,
            recommendations,
            companyName
        });
        this.transformEventsDate();
    }

    transformEventsDate() {
        if (this.props.events.answered)
            this.props.events.answered = new Date(this.props.events.answered);
        if (this.props.events.opened)
            this.props.events.opened = new Date(this.props.events.opened);
        if (this.props.events.received)
            this.props.events.received = new Date(this.props.events.received);
        if (this.props.events.sent)
            this.props.events.sent = new Date(this.props.events.sent);
    }

    getEventStatus() {
        if (this.props.events.answered) return "answered";
        if (this.props.events.opened) return "open";
        if (this.props.events.received) return "received";
        if (this.props.events.sent) return "sent";

        return false;
    }

    getScoreReaction() {
        if (this.props.score < 0) return {};
        if (this.props.score <= 6)
            return {
                icon: "fa-frown",
                label: "Detrator",
                value: "detractors",
                color: "color-red-alert"
            };
        else if ([7, 8].includes(this.props.score))
            return {
                icon: "fa-meh",
                label: "Neutro",
                value: "passive",
                color: "color-yellow-dark"
            };
        else if (this.props.score >= 9)
            return {
                icon: "fa-smile",
                label: "Promotor",
                value: "promotor",
                color: "color-green-medium"
            };
        else return {};
    }

    getTotalRecommendations() {
        return this.props.recommendations?.length || 0;
    }

    getRecommendationsToolitp() {
        let recommendations = ``;
        for (const recommendation of this.props.recommendations) {
            recommendations += `<span><span class='font-weight-bold'>${recommendation.name}: </span><span>${recommendation.contact}</span></span><br>`;
        }
        return recommendations;
    }

    getAnsweredInfo() {
        if (!this.props.events?.answered) return "";
        return `${this.props.name} | ${DateUtils.dateToString(
            this.props.events.answered,
            "dd/MM/yyyy"
        )}`;
    }

    updateEventSent(date = new Date()) {
        this.props.events.sent = date;
    }

    isScoreType(whichType) {
        const types = {
            detractor: this.props.score <= 6,
            passive: [7, 8].includes(this.props.score),
            promotor: this.props.score >= 9
        };
        return types[whichType] || 0;
    }

    received() {
        return this.props.events?.received;
    }

    // notAnswered() {
    //     return (
    //         this.props.events?.opened ||
    //         this.props.events?.received ||
    //         this.props.events?.sent
    //     );
    // }

    notSent() {
        return !this.props.events?.sent;
    }

    answered() {
        return this.props.events?.answered;
    }
}
